// extracted by mini-css-extract-plugin
export default {"columnContainer":"columnContainer__ikCUz","columnContainerBoutique":"columnContainerBoutique___0M3E"};